import React from "react";
import { MdPersonAddAlt1, MdHandshake, MdHistory, MdEvent } from "react-icons/md";
import FormSelectionBox from "../../Components/Form_Selection_Box/Form_Selection_Box";
import "./Form_Selection_Page.css";

const greeting = () => {
  const hour = new Date().getHours();
  return hour < 12 ? "Good morning" : hour < 17 ? "Good afternoon" : "Good evening";
};

function FormSelectionPage() {
  const firstName = (localStorage.getItem("username") || "").trim().split(/\s+/)[0];

  const formSelectionData = [
    {
      boxName: "Customer",
      description: "Register a new walk-in visitor",
      icon: <MdPersonAddAlt1 />,
      accent: "blue",
      navigateLink: "/customer-auth",
    },
    {
      boxName: "Channel Partner",
      description: "Add a partner who brought visitors",
      icon: <MdHandshake />,
      accent: "gold",
      navigateLink: "/channel-partner-auth",
    },
    {
      boxName: "Revisit",
      description: "Log a returning visitor",
      icon: <MdHistory />,
      accent: "green",
      navigateLink: "/revisit",
    },
    {
      boxName: "Event",
      description: "Sign up an event attendee",
      icon: <MdEvent />,
      accent: "plum",
      navigateLink: "/event",
    },
  ];

  return (
    <div className='formSelectionPageWrapper'>
      <div className="selection-hero">
        <span className="selection-eyebrow">
          {greeting()}
          {firstName ? `, ${firstName}` : ""}
        </span>
        <h1>What would you like to register?</h1>
        <p>Pick a form to record today's site activity.</p>
      </div>
      <div className='formSelectionBoxWrapper'>
        {formSelectionData.map((data) => (
          <div key={data.boxName}>
            <FormSelectionBox {...data} />
          </div>
        ))}
      </div>
    </div>
  );
}

export default FormSelectionPage;
